import * as React from 'react';
import { DialogContainer } from './Dialogs';
import { UploadFormProgress, formatByteSize } from '../utils/FileUpload.logic';

interface FileUploadProgressDialogProps {
  progress: UploadFormProgress | null;
  registering: boolean;
}

// 大きなファイルの送信中や保存中に、画面が止まっていないことを知らせる
export const FileUploadProgressDialog: React.FC<FileUploadProgressDialogProps> = function (props) {
  if (props.registering) {
    return (
      <div role="status" aria-live="polite">
        <DialogContainer
          open={true}
          title="保存しています"
          message={<p className="Dialog-message">ファイルの送信が完了しました。保存中です</p>}
        />
      </div>
    );
  }
  if (props.progress !== null) {
    return (
      <div role="status" aria-live="polite">
        <DialogContainer
          open={true}
          title="ファイルを送信しています"
          message={
            <div className="Dialog-message">
              <p>{`${props.progress.fileIndex} / ${props.progress.fileCount} 件目`}</p>
              <p className="Dialog-text_wrap">{props.progress.fileName}</p>
              <p>{`${formatByteSize(props.progress.confirmedBytes)} / ${formatByteSize(props.progress.totalBytes)}`}</p>
              <p>送信が終わるまでこの画面を閉じないでください</p>
            </div>
          }
        />
      </div>
    );
  }
  return null;
};
